import { render, staticRenderFns } from "./HomeSix.vue?vue&type=template&id=cb675ee8&"
import script from "./HomeSix.vue?vue&type=script&lang=js&"
export * from "./HomeSix.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports